import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CRMPageHeaderProps {
  title: string;
  description?: string;
  eyebrow?: ReactNode;
  titleAddon?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function CRMPageHeader({
  title,
  description,
  eyebrow,
  titleAddon,
  actions,
  className,
}: CRMPageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 rounded-2xl border bg-card p-4 shadow-sm lg:flex-row lg:items-center lg:justify-between', className)}>
      <div className="min-w-0 space-y-1.5">
        {eyebrow && <div className="flex flex-wrap items-center gap-2">{eyebrow}</div>}
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
          {titleAddon}
        </div>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>

      {actions && <div className="flex flex-wrap items-center gap-2 lg:justify-end">{actions}</div>}
    </div>
  );
}

export default CRMPageHeader;